
import _ from 'lodash';
import Uploader from '@/components/Uploader/index.vue';

export default {
  name: 'SingleImageUploader',

  componentName: 'SingleImageUploader',

  components: {
    Uploader: Uploader
  },

  props: {
    config: {
      type: Object,
      required: true
    },
    formValue: {
      type: Object,
      required: true
    }
  },

  data: function data() {
    return {
      loading: false,
      fileList: [],
      multiple: false // 当前组件只支持上传单个
    };
  },


  watch: {
    'config.params.fileList': {
      handler: function handler(val) {
        this.fileList = val;
      },

      deep: true
    }
  },

  mounted: function mounted() {
    if (_.get(this.config, 'params.fileList')) {
      this.fileList = _.get(this.config, 'params.fileList');
    }
  },


  methods: {
    handleUploadChange: function handleUploadChange(file, fileList) {
      if (fileList.length > 1) {
        fileList.splice(0, 1);
      }
    },
    handleBeforeUpload: function handleBeforeUpload() {
      // 清空参数，避免上传中就点击提交，
      this.formValue[this.config.prop] = '';
    },
    handleUploadSuccess: function handleUploadSuccess(response, file, fileList) {
      var _this = this;

      if (response.code === 0) {
        fileList[0].name = response.data.origin_name;
        fileList[0].url = response.data.url;
        this.fileList = fileList;
        this.formValue[this.config.prop] = response.data.file_path;
      } else {
        this.$message({
          message: response.msg ? response.msg : '上传失败，请重新尝试',
          type: 'warning'
        });
        setTimeout(function () {
          _this.fileList = [];
          _this.formValue[_this.config.prop] = '';
        });
      }
    }
  }
};